import parseISO from 'date-fns/parseISO';
import max from 'date-fns/max';

import { USER_ROLES } from 'constants/common';

export const getLastUpdatedByCourses = (courses: any) => {
  const coursesWithUpdatedAt = courses.filter(
    (course: any) => !!course.updatedAt,
  );

  if (!coursesWithUpdatedAt || coursesWithUpdatedAt.length === 0) {
    return null;
  }

  return max(
    coursesWithUpdatedAt.map((course: any) => {
      return parseISO(course.updatedAt);
    }),
  );
};

export const getStudentSchools = ({
  user,
  currentStudent,
}: {
  user: any;
  currentStudent: any;
}) => {
  if (!currentStudent) {
    return [];
  }

  const isRootAdmin = user.role === USER_ROLES.ROOT_ADMIN;

  const studentSchools = isRootAdmin
    ? currentStudent.schools
    : currentStudent.schools.filter(
        (school: any) => school.id === user.schoolId,
      );

  return studentSchools;
};

export const getSchoolStudentStatus = ({
  currentStudent,
  studentSchools,
}: {
  currentStudent: any;
  studentSchools: any;
}) => {
  const schoolId = studentSchools[0].id; // SHOW ONLY ADMIN SCHOOL IF IT'S NOT BEFRONT ROOT ADMIN

  const status = currentStudent.status.find(
    (item: any) => item.schoolId === schoolId,
  );

  return status;
};

export const getSchoolStudentCourses = ({
  currentStudent,
  studentSchools,
}: {
  currentStudent: any;
  studentSchools: any;
}) => {
  const schoolId = studentSchools[0].id; // SHOW ONLY ADMIN SCHOOL IF IT'S NOT BEFRONT ROOT ADMIN

  return currentStudent.courses.filter(
    (course: any) => course.schoolId === schoolId,
  );
};
